import {
    validateAddress,
    validateEmail,
    validatePhone,
    validateInternationalPostalCode
} from '../Shared/validations.js';
import { copyFor } from '../../copy/copy';

const validateFullName = values => {
    if (!values) return;
    if (!values.fullName) {
        return { fullName: copyFor('validationErrors', 'fullName', 'petition') };
    }
    const split = values.fullName.split(' ');
    if (split.length > 1 && split[0] !== '' && split[1] !== '') return {};

    return { fullName: copyFor('validationErrors', 'fullName', 'petition') };
};

const validateMessage = values => {
    if (!values) return;
    if (values.message === null || values.message === '') {
        return { message: copyFor('validationErrors', 'message') };
    }
    else if (values.message && values.message.length < 65) return { message: copyFor('validationErrors', 'shortMessage') };
    return {};
};

const validate = (values, props) => {
    let errors = {};

    if (values) {
        const validations = [
            {field: 'fullName', validator: validateFullName},
            {field: 'address', validator: validateAddress},
            {field: 'phone', validator: validatePhone},
            {field: 'postalCode', validator: validateInternationalPostalCode},
            {field: 'email', validator: validateEmail},
            {field: 'message', validator: validateMessage},
        ];

        errors = validations.reduce((acc, el) => {
                    if (Object.keys(values).includes(el.field) && !values.notRequired?.[el.field]){
                        return {...acc, ...el.validator(values)};
                    } else return acc;
                }, errors);
    };
    return errors;
};

export default validate;
